module.exports = __webpack_public_path__ + "next.svg?5fa6301b954885386653f51913b77d00";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/next.svg
// module id = 106
// module chunks = 0